import { deleteAddressUseCase } from '@src/main/modules/messages/application/use-cases/delete/delete-address.usecase';
import { createAddressHttpRepository } from '@src/main/modules/messages/infrastructure/repository/AddressHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useDeleteAddress = () => {
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createAddressHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async (id: string) => {
      if (!repository) throw new Error('Repository not initialized');
      return await deleteAddressUseCase(id, tokenProvider);
    },
  });
};
